import React, { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Card from 'react-bootstrap/Card';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import styles from './ViewFeedbackDetails.module.css';
import ReceiptDetails from './ReceiptDetails';
import ResolutionDetails from './ResolutionDetails';
import SlaDetails from './SlaDetails';
import CommentDetails from './CommentDetails';
import CustomerSatisfaction from './CustomerSatisfaction';
import { useTranslation } from 'react-i18next';
import useAxiosFetchData from '../../../hooks/useAxiosFetchData';
import AcceptFeedback from '../../basic-component/form-component/feedback-form/AcceptFeedback';
import { IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import Snackbar from '@mui/material/Snackbar'
import FeedbackClosure from '../../basic-component/form-component/feedback-form/FeedbackClosure';
import FeedBackDetails from './FeedBackDetails';
import FeedBackDetailsClose from './FeedBackDetailsClose';

const ViewFeedbackDetailsForClose = ({ isUsedWithModal = false, closeParentModal, ...props }) => {
  const { t } = useTranslation();
  const { csrfHeaderName, csrfFormTagName, csrfToken } = useSelector((state) => state.csrf);
  const roles = useSelector((state) => state.role.userCurrRole.description);
  const rolesId = useSelector((state) => state.role.userCurrRole.department.id);
  const [response, setResponse] = useState(null);
  const [activeSection, setActiveSection] = useState("0");
  const [status, setStatus] = useState(null);
  const [map, setMap] = useState({});
  const [lastopen, setLastOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [showFeedbackCloser, setShowFeedbackCloser] = useState(false);
  const [showAcceptbackCloser, setShowAcceptbackCloser] = useState(false);
  const [headers, setHeaders] = useState({
    'X-Csrf-Token': csrfToken,
    'Content-Type': 'application/json'
  });
  const keyComponent = props.keyComponent;
  const [render, setRender] = useState(true);
  const stringifyNestedObjects = (obj) => {
    if (typeof obj === 'object' && obj !== null) {
      Object.keys(obj).forEach((key) => {
        obj[key] = stringifyNestedObjects(obj[key]);
      });
    }
    return obj;
  };
  const formData = new FormData();


  const { response: feedbackDetailsResponse } = useAxiosFetchData({
    url: props.fetchUrl,
    method: 'post',
    body: props.body,
    headers: headers,
    onLoad: true
  });

  const role = useSelector((state) => state.role.userCurrRole.description);
  const feedbackdetails = useCallback(() => {
    const formData = {
      "id": String(props.id),
      "feedbackDesc": "",
      "description": ""
    };
    const formDataJSON = JSON.stringify(formData);



    // axios.post(Callapi, formDataJSON, {
    //   withCredentials: true,
    //   headers
    // })
    //   .then((data) => {
    //     console.log("data", data);
    //     setResponse(data.data);
    //     const stringifiedData = stringifyNestedObjects(data.data);
    //   })
    //   .catch((error) => {
    //     console.log("Error:", error);
    //   });



  }, []);

  useEffect(() => {
    let isString = false;

    for (const key in props) {
      console.log('key:', key);
      if (props.hasOwnProperty(key)) {

        const propValue = props[key];
        console.log('propValue:', propValue);
        if (typeof propValue === 'string' || typeof propValue === 'number') {
          console.log('String property found:', propValue);
          isString = true;
          break; // Exit the loop since we found a string property
        }
      }
    }
    console.log('isString:', isString);
    if (!isString) {
      setResponse(props.data);
    } else {
      feedbackdetails();
      // console.log(roleMap.get(role));
      // console.log(roleMap.get(role).get('CLOSED'))

    }
  }, [props, feedbackdetails]);

  useEffect(() => {
    if (feedbackDetailsResponse) {
      setShowAcceptbackCloser(true);
    }

  }, [feedbackDetailsResponse, showAcceptbackCloser]);


  console.log(map);

  const resetButtons = () => {
    setActiveSection("0");
  };

  const toggleSection = (section) => {
    resetButtons();
    setActiveSection(section);
  };
  console.log(feedbackDetailsResponse);
  const renderActiveSection = () => {
    if (!feedbackDetailsResponse) {
      return null;
    }
    console.log(feedbackDetailsResponse);
    switch (activeSection) {
      case "0":
        return <FeedBackDetailsClose data={feedbackDetailsResponse} />;
      case "1":
        return <ReceiptDetails data={feedbackDetailsResponse} />;
      case "2":
        return <ResolutionDetails data={feedbackDetailsResponse} />;
      case "3":
        return <SlaDetails data={feedbackDetailsResponse} />;
      case "4":
        return <CustomerSatisfaction isStarEnabled={feedbackDetailsResponse.startEnabled} data={feedbackDetailsResponse} />;
      case "5":
        return <CommentDetails keyComponent={props.keyComponent} uploadFormData={formData} />;
      default:
        return null;
    }
  };
  const [currentStatus, setCurrentStatus] = useState("");
  const lasthandleClose = () => {
    setLastOpen(false);
    setShowFeedbackCloser(true);
  };
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={lasthandleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );
  function AppropriateDateComponent({ value }) {
    const generateAppropriateDate = (value) => {
      if (value === undefined || value === null) {
        return "N/A";
      } else {
        var date = new Date(value);
        var month = date.getMonth() + 1;
        var hours = date.getHours();
        var min = date.getMinutes();
        if (min < 10) min = "0" + min;
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12;
        var dd = date.getDate();
        return (
          (dd >= 10 ? dd : "0" + dd) +
          "-" +
          (month >= 10 ? month : "0" + month) +
          "-" +
          date.getFullYear() +
          " " +
          hours +
          ":" +
          min +
          " " +
          ampm
        );
      }
    };
  }
  const handleModalClose = (responseData) => {
    console.log('Feedback response:', responseData);
    setLastOpen(true);
    setSnackbarMessage(responseData);
    setShowAcceptbackCloser(false);
    setShowFeedbackCloser(true);
  };


  useEffect(() => {
    if (feedbackDetailsResponse) {
      // if(props.keyComponent === "Accept"){
      //   formData.append('_csrf', csrfToken);
      //   formData.append('feedbackTypeDesc', feedbackDetailsResponse.feedbackType.description);
      //   formData.append('receiptTargetId', feedbackDetailsResponse.latestReceipt.receiptTargetId);
      //   formData.append('departmentId', rolesId);
      //   formData.append('feedbackId', feedbackDetailsResponse.id);
      //   formData.append('comment', '');
      //   formData.append('_csrf', csrfToken);
      //   formData.append('fileName', '');
      //   formData.append('user.username', '');
      //   formData.append('departmentSlaId[0]', feedbackDetailsResponse.receipt.departmentSlaAssignmentList[0].departmentSlaId);
      //   formData.append('assignmentSLATime[0]', feedbackDetailsResponse.receipt.departmentSlaAssignmentList[0].minuteToCalculate);
      //   formData.append('assignmentTime', feedbackDetailsResponse.receipt.departmentSlaAssignmentList[0].assignmentTime);
      //   formData.append('escalationId[1]', feedbackDetailsResponse.receipt.departmentSlaEscalationList[1].slaId);
      //   formData.append('departmentSlaEscalationId[1]', feedbackDetailsResponse.receipt.departmentSlaEscalationList[1].departmentSlaEscalationId);
      //   formData.append('slaEscalationTime[1]', feedbackDetailsResponse.receipt.departmentSlaEscalationList[1].minuteToCalculate);
      //   formData.append('escalationGroupId[1]', feedbackDetailsResponse.receipt.departmentSlaEscalationList[1].asigneeGroupId);
      //   formData.append('warningTime', AppropriateDateComponent(feedbackDetailsResponse.receipt.departmentSlaEscalationList[0].escalationTime));
      //   formData.append('warningTimeInMinute', feedbackDetailsResponse.receipt.departmentSlaEscalationList[0].minuteToCalculate);
      //   formData.append('feedbackId', feedbackDetailsResponse.id);
      // } 
      // else if(props.keyComponent === 'View'){
      //   formData.append('_csrf', csrfToken);
      //   formData.append('feedbackId', feedbackDetailsResponse[0].id);
      //   formData.append('comment.commentGiven', '');
      //   formData.append('fileName', '');
      //   formData.append('user.username', '');
      //   formData.append('_csrf', csrfToken);
      // }
      // else if(props.keyComponent === 'Close'){
      //   console.log(feedbackDetailsResponse);
      //   formData.append('_csrf', csrfToken);
      //   formData.append('feedbackId', '');
      //   formData.append('feedbackTypeDesc', feedbackDetailsResponse.feedbackType.description);
      //   formData.append('receiptTargetId', feedbackDetailsResponse.receipts.receiptTargetId);
      //   formData.append('departmentId', rolesId);
      //   formData.append('feedbackId', feedbackDetailsResponse.id);
      //   formData.append('comment', '');
      //   formData.append('_csrf', csrfToken);
      //   formData.append('fileName', '');
      //   formData.append('user.username', '');
      //   formData.append('departmentSlaId[0]', feedbackDetailsResponse.receipt.departmentSlaAssignmentList[0].departmentSlaId);
      //   formData.append('escalationId[0]', feedbackDetailsResponse.receipt.departmentSlaAssignmentList[0].slaId);
      //   formData.append('departmentSlaEscalationId[0]', feedbackDetailsResponse.departmentSlaEscalationList[0].departmentSlaEscalationId);
      //   formData.append('escalationGroupId[1]', feedbackDetailsResponse.receipt.departmentSlaEscalationList[0].asigneeGroupId);
      // }



      setCurrentStatus(feedbackDetailsResponse.status);
      if (roles === "ROLE_SPOC") {
        setMap(feedbackDetailsResponse.tabVisibilityMap);
      }
      else {
        setMap(feedbackDetailsResponse.feedbackDetails.tabVisibilityMap);
      }
      console.log(feedbackDetailsResponse);
    }
    console.log(feedbackDetailsResponse)
  }, [feedbackDetailsResponse, currentStatus, map])
  console.log(activeSection);
  return (
    <div className={styles.mainBody}>
      {!isUsedWithModal &&
        (
          <Card className={styles.customCard}>
            <Card.Header className={styles.customHeader}>
              <strong><h2>{t('general.lable.feedbackDetail.text')}</h2></strong>
            </Card.Header>
            <Card.Body className={styles.customBody}>
              <div className={styles.mainContainer}>
                <Box sx={{ width: '100%' }}>


                  <Tabs value={activeSection} onChange={(event, newValue) => toggleSection(newValue)} aria-label="basic tabs example">
                    {map[t('general.tab.feedbackDetails.text')] && <Tab value="0" label={t('general.tab.feedbackDetails.text')} sx={{ color: 'black' }} />}
                    {map[t('general.tab.receiptDetails.text')] && <Tab value="1" label={t('general.tab.receiptDetails.text')} sx={{ color: 'black' }} />}
                    {map[t('general.tab.resolutionDetails.text')] && <Tab value="2" label={t('general.tab.resolutionDetails.text')} sx={{ color: 'black' }} />}
                    {map[t('general.tab.slaDetails.text')] && <Tab value="3" label={t('general.tab.slaDetails.text')} sx={{ color: 'black' }} />}
                    {map[t('general.tab.customerSatisfaction.text')] && <Tab value="4" label={t('general.tab.customerSatisfaction.text')} sx={{ color: 'black' }} />}
                    {map[t('general.tab.commentDetails.text')] && <Tab value="5" label={t('general.tab.commentDetails.text')} sx={{ color: 'black' }} />}
                  </Tabs>

                </Box>
              </div>
              {renderActiveSection()}
            </Card.Body>
          </Card>
        )
      }

      <br />
      {(role === 'ROLE_SPOC' || role === 'ROLE_RESOLVER') && props.keyComponent === 'Accept' && (
        <Card className={styles.customCard}>
          {showAcceptbackCloser && <AcceptFeedback closeParentModal={closeParentModal} isUsedWithModal={isUsedWithModal} data={feedbackDetailsResponse} onClose={handleModalClose} />}
          {lastopen && <Snackbar
            open={lastopen}
            autoHideDuration={5000}
            onClose={lasthandleClose}
            message={snackbarMessage}
            action={action}
          />}
          {showFeedbackCloser && <FeedbackClosure />}
        </Card>
      )}

      {props.renderComponent && currentStatus !== "R" && <div>
        <Card className={styles.customCard}>
          <Card.Header className={styles.customHeader}>
            <strong><h2>{t('general.lable.feedbackClosure')}</h2></strong>
          </Card.Header>
          <Card.Body className={styles.customBody}>

            {props.renderComponent(formData)}
          </Card.Body>
        </Card>
      </div>}
    </div>
  );
};


export default ViewFeedbackDetailsForClose;
